console.log('GSAP');

let tl = gsap.timeline({
	scrollTrigger: {
		trigger: ".pix-hero-home",
		pin: true,
		start: "0",
		end: "bottom",
		scrub: true,

	},
});

//Check screen size for correct animation
let screenSize = document.documentElement.clientWidth || window.innerWidth;

console.log(screenSize);

if (screenSize <= 768) {
	tl.fromTo(".pixelhackers-dripping-arrow", {opacity:1},{opacity:0, duration: 0.5});
	
	tl.fromTo(".pix-hero-device", {opacity:0},{opacity:1, duration: 1});
	tl.fromTo(".pix-hero-home__content", { },{scale:0.666, duration: 2}, "-=1");
	tl.fromTo(".pix-hero-device", {scale:1.5},{scale:1, duration: 2}, "-=2");
} else {
	tl.fromTo(".pix-hero-device", {opacity:0},{opacity:1, duration: 1});
	tl.fromTo(".pixelhackers-dripping-arrow", {opacity:1},{opacity:0, duration: 0.5});
	tl.fromTo(".pix-hero-home__content", { },{scale: 0.5, duration: 2}, "-=1");
	tl.fromTo(".pix-hero-device", {scale:1.75},{scale:0.88, duration: 2}, "-=2");
};